var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.genders.length)?_c('core-basic-drop-down',{staticStyle:{"height":"34px"},attrs:{"items":_vm.genders,"selection":_vm.selected,"forceFirstOption":"","translateLabels":true,"noneLabel":_vm.$t('general.gender.default')},on:{"update:selection":function($event){_vm.selected=$event}}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f605da62","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/Gender.vue
// module id = null
// module chunks = 